import { render } from "./GroupForm.vue?vue&type=template&id=3ec6c6d6&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"

import "./GroupForm.vue?vue&type=style&index=0&id=3ec6c6d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec6c6d6"]])

export default __exports__